import { invoke } from "@tauri-apps/api/core";

import { isTauri } from "@shared/lib/useTauri";

// Native Touch ID для Tauri на macOS: WebAuthn PRF в WKWebView не работает,
// поэтому обёрточный секрет метода "touchid" живёт в macOS Keychain за
// биометрией (BiometryCurrentSet). Чтение секрета показывает системный
// промпт Touch ID; смена набора отпечатков инвалидирует элемент.

export function touchIdSupported(): boolean {
    return isTauri && navigator.userAgent.includes("Mac");
}

export async function touchIdStoreSecret(
    secret: Uint8Array<ArrayBuffer>
): Promise<void> {
    await invoke("touchid_store_secret", { secret: Array.from(secret) });
}

// Показывает системный промпт Touch ID; отмена/ошибка — reject.
export async function touchIdGetSecret(): Promise<Uint8Array<ArrayBuffer>> {
    const bytes = await invoke<number[]>("touchid_get_secret");
    return new Uint8Array(bytes);
}

// Идемпотентно: отсутствие элемента — не ошибка для вызывающего.
export async function touchIdRemoveSecret(): Promise<void> {
    try {
        await invoke("touchid_remove_secret");
    } catch {
        // Элемента нет / не macOS — считаем удалённым.
    }
}
